// @ts-nocheck
import dayjs from "dayjs";
import { DateTime } from "luxon";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
export function getUTCTimeDifferenceWithDate(utcDate1, utcDate2) {
  try {
    // Parse the UTC dates
    const date1 = Date.parse(utcDate1);
    const date2 = Date.parse(utcDate2);

    // Check if parsing was successful
    if (isNaN(date1) || isNaN(date2)) {
      throw new Error("Invalid date format");
    }

    // Calculate the difference in milliseconds
    let difference = date2 - date1;

    // Handle cases where dates span across different days
    const dayInMilliseconds = 24 * 60 * 60 * 1000;
    if (difference < 0) {
      // Add a day if date2 is earlier than date1
      difference += dayInMilliseconds;
    }

    // Get the absolute value of the time difference
    const absoluteDifference = Math.abs(difference);

    // Convert milliseconds to hours and round up
    // const hoursDifference = Math.ceil(absoluteDifference / (1000 * 60 * 60));
    const hoursDifference = absoluteDifference / (1000 * 60 * 60);

    return hoursDifference.toFixed(2);
  } catch (error) {
    return null; // Return null in case of error
  }
}

export const getUniversalDateTimeFormat = ({ dateTime }) => {
  if (dateTime) {
    return `${dayjs(dateTime)?.format?.("ddd")} ${dayjs(dateTime)?.format?.("MM/DD/YYYY")}`;
  } else {
    return null;
  }
};

export const getUniversalDateTimeWithTimeForMedia = ({ dateTime }) => {
  if (dateTime) {
    let formatted = dayjs(dateTime).format("ddd M/D/YYYY hh:mm a");

    // Optional: Removes the space before am/pm to match "05:12pm" exactly
    formatted = formatted.replace(" am", "am").replace(" pm", "pm");

    return formatted;
  } else {
    return null;
  }
};

export function getAbbr(str) {
  if (typeof str === "string") {
    return str
      .split(/\s+/)
      .map((word) => word[0]?.toUpperCase() || "")
      .join("");
  } else {
    return str;
  }
}

export const getUniversalDateWithTimeFormat = ({ dateTime }) => {
  if (dateTime) {
    const timezone = dayjs(dateTime)?.format("zzz");
    return `${dayjs(dateTime)?.format?.("ddd MM/DD/YYYY [at] hh:mm a")} (${getAbbr(timezone)})`;
  } else {
    return null;
  }
};

export const getUniversalDateWithTimeFormatForChat = ({ dateTime }) => {
  if (dateTime) {
    const timezone = dayjs(dateTime)?.format("zzz");
    // return `${dayjs(dateTime)?.format?.("Do MMM YY [at] hh:mm a")} (${getAbbr(timezone)})`;
    return `${dayjs(dateTime)?.format?.("hh:mm a, MM/DD/YY")}`;
  } else {
    return null;
  }
};

export const getUniversalTimeFormat = ({ dateTime }) => {
  if (dateTime) {
    const timezone = dayjs(dateTime)?.format("zzz");
    return `${dayjs(dateTime)?.format?.("hh:mm A")} (${getAbbr(timezone)})`;
  } else {
    return null;
  }
};

/**
 * Generate dates n days before and/or after a given date (excluding the date itself)
 * @param {string} baseDate - The date in 'YYYY-MM-DD' format
 * @param {number} n - Number of days before and/or after
 * @param {Object} options - Configuration object
 * @param {boolean} options.includeBefore - Include dates before baseDate
 * @param {boolean} options.includeAfter - Include dates after baseDate
 * @returns {string[]} - Array of dates in 'YYYY-MM-DD' format
 */
export const generateSurroundingDates = (
  baseDate,
  n,
  options = { includeBefore: true, includeAfter: true },
) => {
  const result = [];

  const { includeBefore, includeAfter } = options;

  if (includeBefore) {
    for (let i = n; i >= 1; i--) {
      result.push(dayjs(baseDate).subtract(i, "day").format("YYYY-MM-DD"));
    }
  }

  if (includeAfter) {
    for (let i = 1; i <= n; i++) {
      result.push(dayjs(baseDate).add(i, "day").format("YYYY-MM-DD"));
    }
  }

  return result;
};

/**
 *
 */
export const convertFromUTCToGivenTimezone = ({ dateStr, timezone }) => {
  let returnVal = "";
  // Parse the UTC time
  const utcDateTime = DateTime.fromISO(dateStr, { zone: "UTC" });

  // Convert the UTC time to the specified timezone
  const localDateTime = utcDateTime.setZone(timezone);

  // Return the local time in ISO format with the appropriate local timezone offset
  const splittedDate = localDateTime?.toISO()?.split("T");

  const time = splittedDate?.[1]?.split("-")?.[0];

  returnVal = splittedDate?.[0] + "T" + time;

  return returnVal;
};

/**
 *
 */
export const formatAMPM = (date) => {
  let hours;
  let minutes;
  if (typeof date === "string") {
    const dateStr = date;
    const splittedDate = dateStr?.split("T")?.[1];
    hours = splittedDate?.split(":")?.[0];
    minutes = splittedDate?.split(":")?.[1];
  } else {
    hours = date.getHours();
    minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
  }
  let ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  let strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

/**
 * Format date with timezone abbreviation for SMS history
 * @param {string} dateString - ISO date string
 * @returns {string} - Formatted date with timezone (e.g., "26 Nov, 10:13 pm (IST)")
 */
export const formatDateTimeWithTimezone = (dateString) => {
  if (!dateString) return "";

  const formattedDate = dayjs(dateString).format("D MMM, h:mm a");
  const timezone = dayjs(dateString).format("zzz");
  const timezoneAbbr = getAbbr(timezone);

  return `${formattedDate} (${timezoneAbbr})`;
};